/* XERAVOS — interacciones propias (vanilla, sin librerías) */
(function () {
  'use strict';
  // El archivo se incluye desde varias secciones: solo debe ejecutarse una vez.
  if (window.__xvLoaded) return;
  window.__xvLoaded = true;
  // Marca un elemento como ya preparado para no enlazar eventos dos veces.
  function fresh(el, key) {
    var k = 'xvBound' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un único observer) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.xv-reveal, .xv-lines, .xv-mask, [data-xv-observe]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          e.target.dispatchEvent(new CustomEvent('xv:in'));
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Titulares por líneas: envuelve cada línea ---------- */
  function initLines() {
    document.querySelectorAll('.xv-lines').forEach(function (el) {
      if (el.dataset.xvDone) return;
      el.dataset.xvDone = '1';
      var html = el.innerHTML.split(/<br\s*\/?>/i);
      el.innerHTML = html.map(function (l, i) {
        return '<span class="xv-line"><span style="--d:' + (i * 110 + (parseInt(el.dataset.delay || 0, 10))) + '">' + l.trim() + '</span></span>';
      }).join('');
    });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-xv-parallax]');
    if (!items.length || reduce || window.__xvPar) return;
    window.__xvPar = true;
    var ticking = false;
    function update() {
      items.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = parseFloat(el.dataset.xvParallax || '0.25');
        el.style.setProperty('--xv-par', (-r.top * k).toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Cifras animadas ---------- */
  function initCounters() {
    document.querySelectorAll('[data-xv-count]').forEach(function (el) {
      if (!fresh(el, 'Count')) return;
      var target = parseFloat(el.dataset.xvCount);
      var dur = parseInt(el.dataset.xvDuration || '1800', 10);
      var host = el.closest('[data-xv-observe]') || el;
      function run() {
        if (reduce) { el.textContent = target; return; }
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * eased);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }
      if (host.classList.contains('is-in')) run();
      else host.addEventListener('xv:in', run, { once: true });
    });
  }

  /* ---------- Pasos con escena sticky ---------- */
  function initSteps() {
    document.querySelectorAll('[data-xv-steps]').forEach(function (root) {
      if (!fresh(root, 'Steps')) return;
      var steps = root.querySelectorAll('.xv-step');
      var imgs = root.querySelectorAll('.xv-steps__frame img');
      var badge = root.querySelector('[data-xv-badge]');
      var badgeN = root.querySelector('[data-xv-badge-n]');
      var list = root.querySelector('.xv-steps__list');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        if (badge) badge.textContent = steps[i].dataset.title || '';
        if (badgeN) badgeN.textContent = i + 1;
      }
      var current = -1;
      var prog = list ? list.querySelector('.xv-steps__progress') : null;
      function activateIdx(i) {
        if (i === current) return;
        current = i;
        activate(i);
      }
      // Paso activo = el que tiene su título más cerca del centro de la pantalla.
      function update() {
        var mid = window.innerHeight * 0.5;
        var best = 0, bestD = Infinity;
        steps.forEach(function (s, k) {
          var h = s.querySelector('h3') || s;
          var r = h.getBoundingClientRect();
          var d = Math.abs(r.top + r.height / 2 - mid);
          if (d < bestD) { bestD = d; best = k; }
        });
        activateIdx(best);
        if (list && prog) {
          var lr = list.getBoundingClientRect();
          var p = Math.max(0, Math.min(1, (mid - lr.top) / lr.height));
          prog.style.setProperty('--p', p.toFixed(3));
        }
        ticking = false;
      }
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Tarjetas con inclinación 3D al cursor ---------- */
  function initTilt() {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('[data-xv-tilt]').forEach(function (card) {
      if (!fresh(card, 'Tilt')) return;
      var max = parseFloat(card.dataset.xvTilt || '6');
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(900px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Acordeones (FAQ y ficha) ---------- */
  function initAccordions() {
    document.querySelectorAll('[data-xv-acc]').forEach(function (root) {
      if (!fresh(root, 'Acc')) return;
      root.querySelectorAll('.xv-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.xv-faq__item');
          var open = item.classList.contains('is-open');
          if (root.dataset.xvAcc === 'single') {
            root.querySelectorAll('.xv-faq__item.is-open').forEach(function (o) {
              o.classList.remove('is-open');
              o.querySelector('.xv-faq__q').setAttribute('aria-expanded', 'false');
            });
          }
          item.classList.toggle('is-open', !open);
          btn.setAttribute('aria-expanded', String(!open));
        });
      });
    });
  }

  /* ---------- Puntos calientes (táctil) ---------- */
  function initHotspots() {
    document.querySelectorAll('.xv-hot__dot').forEach(function (dot) {
      if (!fresh(dot, 'Hot')) return;
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var hot = dot.closest('.xv-hot');
        var was = hot.classList.contains('is-open');
        document.querySelectorAll('.xv-hot.is-open').forEach(function (h) { h.classList.remove('is-open'); });
        if (!was) hot.classList.add('is-open');
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery() {
    document.querySelectorAll('[data-xv-gallery]').forEach(function (g) {
      if (!fresh(g, 'Gallery')) return;
      var imgs = g.querySelectorAll('.xv-gallery__main img');
      var thumbs = g.querySelectorAll('.xv-gallery__thumbs button');
      var i = 0;
      function show(n) {
        if (!imgs.length) return;
        i = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = g.querySelector('[data-xv-prev]'), next = g.querySelector('[data-xv-next]');
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      var sx = null, main = g.querySelector('.xv-gallery__main');
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
        sx = null;
      });
    });
  }

  /* ---------- Cantidad y variantes ---------- */
  function initBuy() {
    document.querySelectorAll('[data-xv-buy]').forEach(function (root) {
      if (!fresh(root, 'Buy')) return;
      var qty = root.querySelector('.xv-qty input');
      if (qty) root.querySelectorAll('[data-xv-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value || '1', 10) + parseInt(b.dataset.xvQty, 10);
          qty.value = Math.max(1, v);
        });
      });
      // Selector de packs: fija la cantidad y el precio mostrado
      var packs = root.querySelector('[data-xv-packs]');
      if (packs) {
        var packQty = root.querySelector('[data-xv-pack-qty]');
        var pPrice = root.querySelector('[data-xv-price]');
        var pCompare = root.querySelector('[data-xv-compare]');
        var pSave = root.querySelector('[data-xv-save]');
        var stickyPrice = document.querySelector('[data-xv-sticky-price]');
        var applyPack = function (input) {
          if (!input) return;
          packQty.value = input.value;
          if (pPrice) pPrice.textContent = input.dataset.price;
          if (pCompare) pCompare.textContent = input.dataset.compare || '';
          if (pSave) {
            var sv = parseInt(input.dataset.save || '0', 10);
            pSave.hidden = !sv;
            pSave.textContent = (pSave.dataset.label || '').replace('[percent]', sv);
          }
          if (stickyPrice) stickyPrice.textContent = input.dataset.price;
        };
        packs.querySelectorAll('input[type=radio]').forEach(function (r) {
          r.addEventListener('change', function () { applyPack(r); });
        });
        applyPack(packs.querySelector('input:checked'));
      }
      var json = root.querySelector('[data-xv-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent);
      var selects = root.querySelectorAll('.xv-variants select');
      var idInput = root.querySelector('input[name="id"]');
      var btn = root.querySelector('[data-xv-add]');
      var price = root.querySelector('[data-xv-price]');
      var compare = root.querySelector('[data-xv-compare]');
      var fmt = function (cents) {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100); }
        catch (e) { return (cents / 100).toFixed(2); }
      };
      function update() {
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); });
        if (!v) { btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.unavailable; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        if (price) price.textContent = fmt(v.price);
        if (compare) { compare.textContent = v.compare_at_price > v.price ? fmt(v.compare_at_price) : ''; }
      }
      selects.forEach(function (s) { s.addEventListener('change', update); });
    });
  }

  /* ---------- Barra de compra flotante ---------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-xv-sticky]');
    var anchor = document.querySelector('[data-xv-add]');
    if (!bar || !anchor || !fresh(bar, 'Sticky')) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var below = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-shown', !e.isIntersecting && below);
      });
    });
    io.observe(anchor);
    var go = bar.querySelector('[data-xv-sticky-go]');
    if (go) go.addEventListener('click', function () { anchor.click(); });
  }

  function init() {
    initLines();
    initReveals();
    initParallax();
    initCounters();
    initSteps();
    initTilt();
    initAccordions();
    initHotspots();
    initGallery();
    initBuy();
    initStickyBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
